'use strict';

var React = require('react');
var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getDividerColor = (theme, isInputFilled, isValueFocused, error) => {
    const { colorMode } = theme;
    if (error) {
        return theme.colors[colorMode].negative;
    }
    if (isInputFilled || isValueFocused) {
        return theme.colors[colorMode].border_Primary;
    }
    return theme.colors[colorMode].background_Overlay_Light;
};
const getDigitSpacing = (theme, maxLength) => {
    switch (maxLength) {
        case 4:
            return theme.spacing.xxLarge;
        case 5:
            return theme.spacing.xLarge;
        case 6:
            return theme.spacing.large;
        default:
            return theme.spacing.xLarge;
    }
};

const dividerWidth = "1.2px";
const cursorWidth = "0.5px";
const cursorHeight = "20px";
const digitWidth = "29px";
const StyledDigitContainer = styled__default.default.div({
    position: "relative",
});
const StyledDigit = styled__default.default.input(({ theme, isInputFilled, isValueFocused, isLastValue, maxLength, error }) => (Object.assign({ boxSizing: "border-box", appearance: "none", outline: "none", textAlign: "center", border: "none", borderRadius: 0, borderBottom: `${dividerWidth} solid ${getDividerColor(theme, isInputFilled, isValueFocused, error)}`, width: digitWidth, marginRight: isLastValue ? 0 : getDigitSpacing(theme, maxLength), paddingLeft: theme.spacing.xxSmall, paddingRight: theme.spacing.xxSmall, paddingBottom: 0, caretColor: "transparent" }, theme.typography["V2.heading1.neutral.bold"])));
const BlinkAnimation = styled.keyframes `
    50% {
      opacity: 0;
    }
`;
const StyledCursor = styled__default.default.div(({ theme, isInputFilled }) => ({
    position: "absolute",
    bottom: "12px",
    left: isInputFilled ? "22px" : "15px",
    border: `${cursorWidth} solid ${theme.colors[theme.colorMode].negative}`,
    backgroundColor: theme.colors[theme.colorMode].negative,
    height: cursorHeight,
}), styled.css `
        animation: ${BlinkAnimation} 1s infinite;
    `);

const Digit = ({ index, value, maxLength, error, isFocussed }) => {
    const digitVal = value[index] || "";
    const isLastValue = index === maxLength - 1;
    const isInputFilled = index < value.length;
    const isActive = React.useMemo(() => {
        const isCurrentValue = index === value.length;
        const isValueComplete = value.length === maxLength;
        return isFocussed && (isCurrentValue || (isLastValue && isValueComplete));
    }, [index, isFocussed, isLastValue, maxLength, value.length]);
    return (React__default.default.createElement(StyledDigitContainer, null,
        React__default.default.createElement(StyledDigit, { readOnly: true, key: index, value: digitVal, isInputFilled: isInputFilled, isValueFocused: isActive, isLastValue: isLastValue, maxLength: maxLength, error: error }),
        isActive && React__default.default.createElement(StyledCursor, { isInputFilled: isInputFilled })));
};
var Digit$1 = React.memo(Digit);

exports.Digit = Digit$1;
//# sourceMappingURL=Digit-BQG2kZ_U.js.map
